import { FormField, TextInput } from 'grommet';
import { FormMarkup } from '@components/basicComponents';
import { getSortedFormFields, handleFormSubmit } from '@utils/forms';
import type { FormExtendedEvent } from 'grommet/components/Form';
import type { FormProps } from '@customTypes/types';

const formTitle: string = 'HPE Software Download Support Request';

export const SWDRequestGLCPForm = (props: FormProps): JSX.Element => {
  const onSubmit = ({ target }: FormExtendedEvent): void => {
    const namespace = 'hpe_swd_supportcenter_glcp';
    const subject = 'Software Download Request (GPST): {formId}';
    const data = getSortedFormFields(target, namespace, subject);

    handleFormSubmit(data, props.onSuccess, props.onError, props.onLoading);
  };

  return (
    <FormMarkup
      onSubmit={onSubmit}
      formTitle={formTitle}
      disclaimer={'Please fill out the following information so that we may investigate your software download issue and respond back to you with information to resolve your question.'}
      passportId={true}
      country={true}
      hideDetails={true}
      formFields={
        <>
          <FormField name="softwareDownloadId" htmlFor="software-download-id" label="Please indicate Software Download needed (name or Software ID)" required>
            <TextInput id="software-download-id" name="softwareDownloadId" placeholder="Please indicate Software Download needed (name or Software ID)" />
          </FormField>

          <FormField name="softwareDownloadUrl" htmlFor="software-download-url" label="Software Download page URL" required>
            <TextInput id="software-download-url" name="softwareDownloadUrl" placeholder="Software Download page URL" />
          </FormField>
        </>
      }
    />
  );
};
